import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from "reactstrap";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// service
import {
  updateProfile,
  getProfilesById,
  getProfileScreensById,
} from "../../../utils/services/profilesScreen";
// componentes
import DropOption from "./DropOption";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

function ModalEditProfile(props) {
  const { isOpen, toggle, getProfilesList, profileSelected } = props;
  // produtos
  const [description, setDescription] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [productsWithActions, setProductsWithActions] = useState([]);
  const [showAllEvents, setShowAllEvents] = useState(false);
  // carregamento
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  // erros
  const [errors, setErrors] = useState({});
  // alertas
  const [alertSuccess, setAlertSuccess] = useState("");
  const [alertError, setAlertError] = useState(false);

  // verificar erros
  function verifyErrors(e) {
    setLoadingSubmit(true);

    if (!e.target[0].value) {
      setErrors({
        name: "O campo Nome é obrigatório",
      });
      setLoading(false);
      return;
    } else setErrors({});

    if (
      productsWithActions.filter(
        (e) => e.canView || e.canCreate || e.canEdit || e.canDelete
      ).length === 0
    ) {
      setErrors({
        screens: "Selecione ao menos uma tela",
      });
      setLoading(false);
      return;
    } else setErrors({});

    submitForm(e);
  }

  async function submitForm(e) {
    try {
      // montar a estrutura para api
      const data = {
        description: e.target[0].value,
        isDefault: false,
        contractId: props.state.global_user_data.data.theme[0].id,
        showAllEvents: showAllEvents,
        screensPermission: productsWithActions
          .filter((e) => e.canCreate || e.canEdit || e.canView || e.canDelete)
          .map((obj) => {
            return {
              productId: obj.productId,
              screenId: obj.screenId,
              canCreate: obj.canCreate || false,
              canUpdate: obj.canEdit || obj.canCreate || false,
              canRead:
                obj.canView ||
                obj.canCreate ||
                obj.canEdit ||
                obj.canDelete ||
                false,
              canDelete: obj.canDelete || false,
              profileId: profileSelected.id,
              screenName: obj.screenName,
            };
          }),
      };

      const res = await updateProfile(data, profileSelected.id);

      if (res.message === "PROFILE_UPDATED") {
        setAlertSuccess(true);
        getProfilesList();
      } else if (res.data.message === "PROFILE_ALREADY_EXISTS") {
        setLoadingSubmit(false);
        setAlertError(true);
      }
    } catch (error) {
      console.log("erro", error);
    } finally {
      setLoading(false);
    }
  }

  // pegar dados da api
  function getProfilesByIdFunc() {
    getProfilesById(profileSelected.id)
      .then((res) => {
        if (res.message === "PROFILE_FOUND") {
          setShowAllEvents(res.data.showAllEvents);
          setDescription(res.data.description);
        }
      })
      .catch((error) => console.log("erro", error));
  }

  // pegar telas com ações do usuário da api e formatar para o padrão da aplicação
  async function getProfileScreensByIdFunc() {
    try {
      const res = await getProfileScreensById(profileSelected.id);

      if (res.message === "PROFILE_SCREEN_FOUND" && res.data[1] > 0) {
        const list = [];
        const seen = new Set();

        res.data[0].map((obj) => {
          const foundProducts =
            props.state.global_user_data.data.foundProducts.find(
              (e) => e.id === obj.screenId
            );

          const key = `${obj.profileId}-${obj.screenId}-${obj.productid}`;
          if (!seen.has(key)) {
            seen.add(key);

            list.push({
              canCreate: obj.canCreate,
              canEdit: obj.canUpdate,
              canView: obj.canRead,
              canDelete: obj.canDelete,
              id: obj.id,
              profileId: obj.profileId,
              screenId: obj.screenId,
              screenName: obj.screenName,
              productId: obj.productid,
              product: foundProducts?.namemainproduct || "",
            });
          }
        });

        setProductsWithActions(
          list.filter(
            (e) => e.canCreate || e.canDelete || e.canEdit || e.canView
          )
        );
      }
    } catch (error) {
      console.log("screen erro", error);
    } finally {
      setLoading(false);
    }
  }

  // pegar apenas os produtos do redux e setar no state
  useEffect(() => {
    var products = [];

    props.state.global_user_data.data.foundProducts.map((e) => {
      var searchProducts = products.find(
        (product) => product.name === e.namemainproduct
      );

      if (!searchProducts) {
        products.push({
          name: e.namemainproduct,
          id: e.idmainproduct,
        });
      }
    });

    setAllProducts(products);
  }, []);

  useEffect(() => {
    if (profileSelected && allProducts?.length > 0) {
      getProfilesByIdFunc();
      getProfileScreensByIdFunc();
    }
  }, [profileSelected, allProducts]);

  return (
    <>
      {alertError && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => {
            setAlertError(false);
          }}
        >
          {"Já existe um perfil com esse nome."}
        </SweetAlert>
      )}
      {alertSuccess && (
        <SweetAlert
          success
          title="Editado"
          onConfirm={() => {
            setAlertSuccess(false);
            toggle();
          }}
        >
          Perfil Editado com sucesso!
        </SweetAlert>
      )}
      <Modal isOpen={isOpen} centered size="lg">
        <ModalHeader toggle={toggle}>Editar Perfil</ModalHeader>
        <ModalBody>
          {loading ? (
            <p style={{ textAlign: "center" }}>Carregando ...</p>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                verifyErrors(e);
              }}
            >
              <Row>
                <Col md={7} style={{ marginTop: 10 }}>
                  <label className="form-label">Nome*</label>
                  <input
                    className="form-control"
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  {errors && errors.name && (
                    <a style={{ color: "red" }}>{errors.name}</a>
                  )}
                </Col>

                <Col md={5} style={{ marginTop: 10 }}>
                  <label className="form-label">
                    Pode visualizar todos os eventos?*
                  </label>
                  <div style={{ display: "flex" }}>
                    <div
                      className="form-check mb-3"
                      style={{ marginRight: 10 }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="viewEvent"
                        id="viewEvent2"
                        value="option2"
                        checked={showAllEvents === false ? true : false}
                        onClick={() => setShowAllEvents(false)}
                      />
                      <label className="form-check-label" htmlFor="viewEvent2">
                        Não
                      </label>
                    </div>
                    <div
                      className="form-check mb-3"
                      style={{ marginRight: 10 }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="viewEvent"
                        id="viewEvent1"
                        value="option1"
                        checked={showAllEvents === true ? true : false}
                        onClick={() => setShowAllEvents(true)}
                      />
                      <label className="form-check-label" htmlFor="viewEvent1">
                        Sim
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginTop: 20 }}>
                <Col md={12}>
                  <label className="form-label">Produtos e Telas *</label>
                </Col>
              </Row>

              {allProducts &&
                allProducts.length > 0 &&
                allProducts.map((e, i) => (
                  <div key={`product${i}`}>
                    <DropOption
                      data={e}
                      allScreens={
                        props.state.global_user_data.data.foundProducts
                      }
                      productsWithActions={productsWithActions}
                      setProductsWithActions={setProductsWithActions}
                      profileId={profileSelected.id}
                    />

                    <div className="line" style={{ marginTop: 10 }} />
                  </div>
                ))}
              {errors && errors.screens && (
                <a style={{ color: "red" }}>{errors.screens}</a>
              )}

              <Row
                style={{
                  width: "100%",
                  margin: "20px auto 0",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  color="danger"
                  className="btn waves-effect waves-light"
                  style={{ width: 80, marginRight: 15 }}
                  onClick={() => toggle()}
                >
                  Fechar
                </Button>
                <ButtonSpinner title={"Salvar"} isLoading={loadingSubmit} />
              </Row>
            </form>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(ModalEditProfile);
